<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @onSearchDataChange="onSearchDataChange"
            @getTableConfigList="getTableConfigList"
            @btn-event="goDetail"
        >
            <template v-slot:page-module-btn>
                <div class="btnList">
                    <reportExport #default="{ submit }" reportCode="">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="searchExport(submit)"
                            >导出</el-button
                        >
                    </reportExport>
                </div>
            </template>
        </m-table>
        <detail
            ref="detail"
            :rowData="listData[this.currentIndex]"
            :barcodeNo="barcodeNo"
            :currentIndex="currentIndex"
            :total="listData.length"
            :stateDictList="stateDictList"
            @changeIndex="changeIndex"
        />
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import detail from './detail';
import { fourYardsInOne } from '@/modules/sn/api/lcbsManagement.js';
import { tableConfig } from './tableConfig.js';
import formatTime from '@/utils/common.js';
import { cloneDeep } from 'lodash';
import reportExport from '@/components/lots/reportExportPlugin';
import { dictWithUrl } from '@/modules/sn/components/basicDataDialog/api';
const EXPORT_API = '/api-sn/lbcs/fourYardsInOne/export';
export default {
    name: 'barcodeMerge',
    components: { Paper, mTable, detail, reportExport },
    data() {
        return {
            barcodeNo: '', // 弹出框单号
            currentIndex: 0, // 弹出框下标
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {}, // 搜索框数据
            pickerMinDate: '', // 计算禁用时间
            tableConfig: {}, // 表格配置
            listExportParams: {}, // 导出参数（默认当前查询记录）
            exportColumns: [], // 导出行
            day30: 30 * 24 * 60 * 60 * 1000,
            shipStatusDictList: {}, // 出货状态字典
            stateDictList: {} // 可用状态字典
        };
    },
    created() {
        this.tableConfig = this.setTableConfig();
        this.dictData();
    },
    methods: {
        // 获取字典
        async dictData() {
            const option = await dictWithUrl('SHIP_STATUS,AVAILABLE_STATUS'); //  SHIP_STATUS 出货状态； AVAILABLE_STATUS 可用状态
            if (+option.code === 0) {
                option.data.SHIP_STATUS.forEach((item) => {
                    this.shipStatusDictList[item.code] = item.name;
                });
                option.data.AVAILABLE_STATUS.forEach((item) => {
                    this.stateDictList[item.code] = item.name;
                });
            }
        },
        // 列配置
        getTableConfigList(data) {
            this.exportColumns = data;
        },
        // 动态设置配置行
        setTableConfig() {
            const newConfig = cloneDeep(tableConfig);
            newConfig.searchList.searchTxt.push({
                type: 'datePicker',
                value: 'billDate',
                clearable: true,
                disabled: true,
                span: 6,
                name: '出货时间',
                pickerOptions: {
                    shortcuts: [
                        {
                            text: this.$translate('lang.E3202101270017', {
                                defaultText: '最近一周'
                            }),
                            onClick(picker) {
                                picker.$emit('pick', [
                                    formatTime.initStartDate(6),
                                    formatTime.initEndDate()
                                ]);
                            }
                        },
                        {
                            text: this.$translate('lang.E3202101270019', {
                                defaultText: '最近一个月'
                            }),
                            onClick(picker) {
                                picker.$emit('pick', [
                                    formatTime.initStartDate(30),
                                    formatTime.initEndDate()
                                ]);
                            }
                        }
                    ],
                    onPick: ({ maxDate, minDate }) => {
                        if (minDate && this.pickerMinDate) {
                            this.pickerMinDate = null;
                        } else if (minDate) {
                            this.pickerMinDate = minDate.getTime();
                        }
                    },
                    disabledDate: (time) => {
                        if (time > new Date()) return true;
                        if (this.pickerMinDate) {
                            return (
                                time.getTime() >
                                    this.pickerMinDate + this.day30 ||
                                time.getTime() < this.pickerMinDate - this.day30
                            );
                        }
                        return false;
                    }
                }
            });
            return newConfig;
        },
        // 检查输入参数
        checksSearchData(data) {
            const arr = Object.keys(data);
            if (arr.length < 1) {
                this.$message.warning('请输入查询条件');
                return false;
            } else if (arr.length === 1 && arr[0] === 'billDate') {
                this.$message.warning('请输入查询条件');
                return false;
            }
            return true;
        },
        onSearchDataChange(data) {
            this.tableConfig.searchList.searchTxt[7].disabled =
                // !Object.hasOwn(data, 'actContainerNo') ||
                !data.actContainerNo || data.actContainerNo.trim().length < 1;
            this.searchData = data;
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.search(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.search(this.searchData);
        },
        // 查询
        search(data) {
            const flag = this.checksSearchData(data);
            flag && this.getData(data);
        },
        getData(data) {
            const params = cloneDeep(data);
            if (params.actContainerNo && params.billDate) {
                params.billBeginDate = formatTime.formatDateTime(
                    data.billDate[0]
                );
                params.billEndDate = formatTime.formatDateTime(
                    data.billDate[1]
                );
            }
            delete params.billDate;
            params.pageSize = this.tableConfig.page.pageSize;
            params.pageNo = this.tableConfig.page.pageNo;
            this.listExportParams = params;
            this.listData = [];
            fourYardsInOne(params).then((res) => {
                if (res.code + '' === '0' && res.data) {
                    this.setData(res.data);
                }
            });
        },
        setData(data) {
            const list = data.list || [];
            this.pageTotal = data.totalCount;
            this.listData = list.map((item) => {
                item.state = item.state ? this.stateDictList[item.state] : '';
                item.shipStatus = item.shipStatus
                    ? this.shipStatusDictList[item.shipStatus]
                    : '';
                item.id = item.id + '';
                return item;
            });
        },
        goDetail(row, index) {
            this.currentIndex = index;
            this.barcodeNo = row.barcode;
            this.$refs.detail.open(row.barcode);
        },
        changeIndex(index) {
            this.currentIndex = index;
            this.barcodeNo = this.listData[index].barcode;
        },
        // 导出
        searchExport(submit) {
            const columns = [];
            this.exportColumns.forEach((item) => {
                if (!item.hiddenColumn) {
                    columns.push(item.prop);
                }
            });
            const params = {
                EXPORT_API,
                columns: columns,
                ...this.listExportParams
            };
            if (!this.listData.length) {
                this.$message.warning(
                    this.$translate('lang.EXC202101260002', {
                        defaultText: '暂无导出数据,请重新设置查询条件'
                    })
                );
                return;
            }
            submit(params);
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 250px) !important;
    }
}
</style>
